import type { FC } from "react";
import React from "react";
import { Flex } from "@edreamsodigeo/prisma-design-system";

import { getAutoRenewalPolicy } from "~/components/common/MembershipWithInstallmentsDisclaimer/tools/utils";
import type { SubscriptionResponse } from "~/generated/graphql";
import MembershipWithInstallmentsDisclaimer from "~/components/common/MembershipWithInstallmentsDisclaimer/MembershipWithInstallmentsDisclaimer";

export const YearlyWithMonthlyDisclaimer: FC<{
  offer: SubscriptionResponse;
}> = ({ offer }) => {
  const autoRenewalPolicy = getAutoRenewalPolicy(offer);

  return autoRenewalPolicy ? (
    <Flex>
      <MembershipWithInstallmentsDisclaimer
        autoRenewalPolicy={autoRenewalPolicy}
      />
    </Flex>
  ) : null;
};
